import React from 'react';
import { ChevronDown } from 'lucide-react';
import { faq } from '../../content';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

// Valores por defecto
const defaultFaq = {
  sectionLabel: "FAQ",
  sectionTitle: "Preguntas frecuentes",
  sectionSubtitle: "Resolvemos tus dudas más comunes",
  items: []
};

export const FAQSection = () => {
  // Obtener contenido con fallbacks
  const content = {
    sectionLabel: faq?.sectionLabel || defaultFaq.sectionLabel,
    sectionTitle: faq?.sectionTitle || defaultFaq.sectionTitle,
    sectionSubtitle: faq?.sectionSubtitle || defaultFaq.sectionSubtitle,
    items: faq?.items || defaultFaq.items
  };

  if (content.items.length === 0) return null;

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#CFA935] font-semibold text-sm uppercase tracking-wider">
            {content.sectionLabel}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-[#013C5D]">
            {content.sectionTitle}
          </h2>
          <p className="mt-4 text-gray-600 text-lg">
            {content.sectionSubtitle}
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {content.items.map((item, idx) => (
            <AccordionItem
              key={item.id || idx}
              value={`item-${idx}`}
              className="bg-gray-50 rounded-2xl border border-gray-100 overflow-hidden hover:border-[#CFA935]/30 transition-colors"
            >
              <AccordionTrigger className="px-6 py-5 text-left hover:no-underline group">
                <span className="text-[#013C5D] font-semibold pr-4 group-hover:text-[#CFA935] transition-colors">
                  {item.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-5 text-gray-600 leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
